import React, { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { isNullUndefined } from '@/main/services/utils';
import { usePartTypeReducer } from '@/main/store/partType';
import { useReasonReducer } from '@/main/store/reason';
import LoadingComponent from '@/main/components/shared/loading/loadingComponent';

import RowSupplierRequoteOrderedClaim from './rowSupplierRequoteOrderedClaim/rowSupplierRequoteOrderedClaim';
import * as S from './styles';
import { IRequoteClaim } from '../modalRequoteClaim';
import { IItemFormRequoteSupplierOrdered, IQuoteNoSupplierAssignedItemResponse } from '../typesModalRequoteClaim';

interface ISectionRequoteProcurementProps {
  fieldsProcurement: IItemFormRequoteSupplierOrdered[];
  isLoadingParts: boolean;
}

function SectionRequoteProcurement({
  fieldsProcurement,
  isLoadingParts,
}: ISectionRequoteProcurementProps) {
  const { partType: partTypeReducer } = usePartTypeReducer();
  const { reason: reasonReducer } = useReasonReducer();

  type keyFieldsItems = keyof IQuoteNoSupplierAssignedItemResponse;
  const nameField = (name: keyFieldsItems, index: number) => `sectionQuote.parts.${index}.${name}`;

  const {
    control,
    setValue,
  } = useFormContext<IRequoteClaim>();


  const allCheckboxesSelected = useMemo(() => {
    if (isNullUndefined(fieldsProcurement)) return false;

    return fieldsProcurement.every(item => item.items.every(i => i.isSelected));
  }, [JSON.stringify(fieldsProcurement)])


  if (isLoadingParts) return <LoadingComponent />;
  return (
    <S.Container>
      {fieldsProcurement.map((supplier, index) => (
        <RowSupplierRequoteOrderedClaim
          key={supplier.guidProcurementSupplier}
          indexSupplier={index}
          supplier={supplier}
        />
      ))}
    </S.Container>
  )
}

export default SectionRequoteProcurement